import "core-js/stable";
import "regenerator-runtime/runtime";
import Sortable from 'sortablejs';
import SelectorSet from 'selector-set';
var Alert = require("../modules/alert");

import {
  Chart,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  DoughnutController,
  ArcElement
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  ArcElement,
  DoughnutController,
  ChartDataLabels
);

Chart.defaults.plugins.datalabels.display = false;

require("channels")

class DelegatedEvents {
  constructor() {
    this.bubbleEvents = {};
    this.captureEvents = {};
    this.propagationStopped = new WeakMap();
    this.immediatePropagationStopped = new WeakMap();
    this.currentTargets = new WeakMap();
    this.currentTargetDesc = Object.getOwnPropertyDescriptor(Event.prototype, 'currentTarget');

    this.before = this.before.bind(this);
  }

  before(subject, verb, fn) {
    let source = subject[verb];

    subject[verb] = function () {
      fn.apply(subject, arguments);
      return source.apply(subject, arguments);
    };

    return subject;
  }

  matches(selectors, target, reverse) {
    let queue = [];
    let node = target;

    do {
      if (node.nodeType !== 1) break;

      var _matches = selectors.matches(node);

      if (_matches.length) {
        let matched = {
          node: node,
          observers: _matches
        };

        if (reverse) {
          queue.unshift(matched);
        } else {
          queue.push(matched);
        }
      }
    } while (node = node.parentElement);

    return queue;
  }

  trackPropagation() {
    this.propagationStopped.set(this, true);
  }

  trackImmediate() {
    this.propagationStopped.set(this, true);
    this.immediatePropagationStopped.set(this, true);
  }

  getCurrentTarget() {
    return this.currentTargets.get(this) || null;
  }

  defineCurrentTarget(event, getter) {
    if (!this.currentTargetDesc) return;
    Object.defineProperty(event, 'currentTarget', {
      configurable: true,
      enumerable: true,
      get: getter || this.currentTargetDesc.get
    });
  }

  canDispatch(event) {
    try {
      event.eventPhase;
      return true;
    } catch (_) {
      return false;
    }
  }

  dispatch(event) {
    if (!this.canDispatch(event)) return;
    let events = event.eventPhase === 1 ? this.captureEvents : this.bubbleEvents;
    let selectors = events[event.type];
    if (!selectors) return;
    var queue = this.matches(selectors, event.target, event.eventPhase === 1);
    if (!queue.length) return;
    this.before(event, 'stopPropagation', this.trackPropagation);
    this.before(event, 'stopImmediatePropagation', this.trackImmediate);
    this.defineCurrentTarget(event, this.getCurrentTarget);

    for (let i = 0, len1 = queue.length; i < len1; i++) {
      if (this.propagationStopped.get(event)) break;
      let matched = queue[i];
      this.currentTargets.set(event, matched.node);

      for (let j = 0, len2 = matched.observers.length; j < len2; j++) {
        if (this.immediatePropagationStopped.get(event)) break;
        matched.observers[j].data.call(matched.node, event);
      }
    }

    this.currentTargets["delete"](event);
    this.defineCurrentTarget(event);
  }

  on(names, selector, options, fn) {

    if (typeof options == 'function') {
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      // There are no options so just adjust the calling parameters into the right variables
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      fn = options;
      options = {};
    }

    let capture = options.capture ? true : false;
    let events = capture ? this.captureEvents : this.bubbleEvents;

    for (let name of names.split(' ')) {
      let selectors = events[name];

      if (selectors) selectors.remove(selector);

      if (!selectors) {
        selectors = new SelectorSet();
        events[name] = selectors;
        document.addEventListener(name, (event) => this.dispatch(event), capture);
      }

      selectors.add(selector, fn);
    }
  }

  off(names, selector, options, fn) {
    if (options == undefined || typeof options == 'function') {
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      // There are no options so just adjust the calling parameters into the right variables
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      fn = options;
      options = {};
    }

    let capture = options.capture ? true : false;
    let events = capture ? this.captureEvents : this.bubbleEvents;

    for (let name of names.split(' ')) {
      let selectors = events[name];
      if (!selectors) continue;

      if (fn) {
        selectors.remove(selector, fn);
      }
      else {
        selectors.remove(selector);
      }
      if (selectors.size) continue;
      delete events[name];
      document.removeEventListener(name, (event) => this.dispatch(event), capture);
    }
  }

  fire(name, selector, detail) {
    const target = document.querySelector(selector);
    if (target) {
      return target.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
      }));
    }
  }

}

const delegated = new DelegatedEvents;

document.addEventListener("DOMContentLoaded", function() {

  window.Chart = Chart;

  window.sortable = Sortable;

  window.chart_icon = function (chart_type) {
    var t;

    switch (chart_type) {
      case 'Pie':
      case 'Ring':
        // Use the pie chart icon for pie and ring charts
        t = 'chart-pie-alt';
        break;
      case 'Vbar':
        t = 'chart-bar';
        break;
      case 'Hbar':
        return "<i class=\"fas fa-fw fa-chart-bar as-a-hbar\" aria-hidden=\"true\"></i>"
        break;
      case 'Dial':
        t = 'tachometer-alt';
        break;
      case 'Html':
      case 'HtmlOverlay':
        t = 'table';
        break;
      case 'Plot':
        t = 'chart-line';
        break;
      case 'Comment':
        t = 'comment';
        break;
      case 'Sentiment':
        t = 'smile';
        break;
      case 'Cloud':
        t = 'cloud';
        break;
      case 'Map':
        t = 'map-marker-alt';
        break;

      default:
        t = 'user-cog';
    }

    return '<i class="fas fa-fw fa-'+t+'" aria-hidden="true"></i>';

  }

  window.delegatedEvents = function() {
    return delegated;
  }

  window.Alert = new Alert.Alert();

  window.autocomplete = function(onSelection) {
        var headers = new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        });

        new autoComplete({
          data: {                             // Data src [Array, Function, Async] | (REQUIRED)
            src: async () => {
              const query = document.querySelector("#autoComplete").value;
              // Fetch External Data Source
              const source = await fetch(url('lookup_organisation', {q: query}), {headers: headers});
              // Format data into JSON
              const data = await source.json();
              // Return Fetched data
              return data;
            },
            key: ["title"],
            cache: false
          },
          placeHolder: "Organisation name",    // Place Holder text                 | (Optional)
          selector: "#autoComplete",           // Input field selector              | (Optional)
          threshold: 2,                        // Min. Chars length to start Engine | (Optional)
          debounce: 300,                       // Post duration for engine to start | (Optional)
          searchEngine: "strict",              // Search Engine type/mode           | (Optional)
          maxResults: 20,                      // Max. number of rendered results   | (Optional)
          resultsList: {
            render: true,
            container: function container(source) {
              source.setAttribute("id", "autoComplete_list");
              let rect = document.getElementById('autoComplete').getBoundingClientRect();
              source.style.left = '' + Math.floor(rect.x) + 'px';
              source.style.top = '' + Math.ceil(rect.bottom) + 'px';
              source.style.width = '' + Math.ceil(rect.width) + 'px';
            },
            destination: document.querySelector("#autoComplete"),
            position: "afterend",
            element: "ul"
          },
          highlight: true,                       // Highlight matching results      | (Optional)
          onSelection: onSelection,
          onSingleItem: onSelection
        });

  }

  window.openSetPasswordDialog = function(id, options) {
    $('#changing-own-password').removeClass('is-hidden');
    if (id != 0) $('#changing-own-password').addClass('is-hidden');

    if (options && options.msg) {
      $('#set-password-dialog .delete').addClass('is-hidden');
      $('#changing-own-password').addClass('is-hidden');
      $('#current-user-password').val(options.current_password);

      var el = document.getElementById('reset-failure');

      if (el) {
        $(el).removeClass()
        .addClass('notification is-radiusless')
        .addClass(options.msg.background || 'has-background-warning').addClass(options.msg.color || 'has-text-warning-dark');
        $(el).html(options.msg.message);
      }
    }
    else {
      $('#set-password-dialog .delete').removeClass('is-hidden');
      $('#current-user-password').val();
      $('#reset-failure').removeClass().addClass('notification is-radiusless');
      $('#reset-failure').empty();
    }

    $('#set-password-dialog').addClass('is-active');

    $('#new-password, #new-confirm').val('');
    $(id == 0 ? '#current-user-password' : '#new-password').focus();

    $('#change-password').off('click');
    $('#change-password').on('click',  function(event) {
      resetPassword(id, options);
    });

    $("#set-password-body").off('keyup');
    $("#set-password-body").on('keyup', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        resetPassword(id, options);
      }
    });
  }

  window.resetPassword = function(id, options) {
    const params = {
      current: document.querySelector('#current-user-password').value,
      password: document.querySelector('#new-password').value,
      confirm_password:  document.querySelector('#new-confirm').value
    }

    $.post( `/user/reset/${id}`, params)
    .done(msg => {
      document.querySelector('#set-password-dialog').classList.remove('is-active');
      if (options && typeof options.callback == 'function') {
        options.callback(msg);
      }
    })
    .fail(jqXHR => {
      window.Alert.setFailMsg(jqXHR, 'reset-failure');
    });
  }

  window.delegatedEvents().on('click', '.modal .delete', event => {
    event.target.closest('.modal').classList.remove('is-active');
  });

});
